import Component from '../abstracts/Component';
import vex from 'vex-js';
import Cookies from 'js-cookie';
import ModalComponent from "./ModalComponent";

export default class NewsletterPopupComponent extends Component {

  get COOKIE_NAME() {
    return {
      popUpHide: 'modal_newsletter_popup_hide',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.modalComponent = new ModalComponent();
    this.counter = 0;
    this.timerId = null;
    this.timeoutId = null;
  }

  // VEX OPEN POPUP //
  openPopUp(content) {
    // check the cookies, if cookie already set do not show the popup
    const newsCookie = Cookies.get(this.COOKIE_NAME.popUpHide);
    if (!newsCookie) {
      const ctx = this;
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");
      const modalContent = doc.querySelector('[data-modal="nl-modal"]');
      vex.open({
        unsafeContent: modalContent,
        showCloseButton: true,
        className: '--newsletter',
        closeClassName: 'icon close',
        afterOpen: function () {
          this.closeEl.classList.remove("vex-close");
          Cookies.set(ctx.COOKIE_NAME.popUpHide);
          ctx.emitTimerEvent(ctx.$customEvents.POPUP_EVENTS.pauseTimer);
          ctx.modalComponent.importComponents("NewsletterContentComponent")
            .then(({default: module}) => {
              const component = new module(modalContent);
              component.render();
            })
        },
        afterClose: function () {
          ctx.emitTimerEvent(ctx.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
    }
  }

  incrementTimer() {
    this.counter++;
    if (this.counter >= this.$component.dataset.jsTimer) {
      this.pauseTimer();
      this.openPopUp(this.$component.innerHTML);
    }
  }

  // TIMER LOGIC //
  startTimer() {
    this.timerId = setInterval(this.incrementTimer.bind(this), 1000);
  }

  pauseTimer() {
    this.timerId ? clearInterval(this.timerId) : '';
    this.timeoutId ? clearTimeout(this.timeoutId) : '';
  }

  resumeTimer() {
    this.timerId = setInterval(this.incrementTimer.bind(this), 1000);
  }

  timerEvents() {
    this.$on(this.$customEvents.POPUP_EVENTS.pauseTimer, () => {
      this.pauseTimer();
    });
    this.$on(this.$customEvents.POPUP_EVENTS.resumeTimer, () => {
      if (!Cookies.get(this.COOKIE_NAME.popUpHide)) {
        // wait 2 seconds then resume timer
        this.timeoutId = setTimeout(this.resumeTimer.bind(this), 2000);
      }
    });
  }

  //externalize from vex
  emitTimerEvent(event, payload= {}) {
    this.$emit(event, payload);
  }

  bindEvents() {
    this.$on(this.$customEvents.NL_POPUP_EVENTS.close, ()=> {
    const popup = document.querySelector('.vex-content');
    if (popup) {
      popup.querySelector('.close').click();
    }
    });
  }

  render() {
    // check the cookies, if cookie alredy set do not start the component
    const newsCookie = Cookies.get(this.COOKIE_NAME.popUpHide);
    if (!newsCookie) {
      // start timer
      this.startTimer();
      // bind timer events to component
      this.timerEvents();

      this.bindEvents();
    }
  }
}
